import { Cog } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCog = mkIcon(Cog);
